import { Pipe, PipeTransform } from '@angular/core';
import {
    TravellerDataTranslationService
} from "libraries/service/traveller-data-translation/traveller-data-translation.service";
import { ICustomer, IHolder, ITraveller } from "libraries/service/resources/booking/interfaces/IGetBookings";

@Pipe({
    name: 'travellerType'
})

export class TravellerTypePipe implements PipeTransform {
    constructor(private readonly travellerDataTranslationService: TravellerDataTranslationService) {
    }

    public transform(traveller: ITraveller | IHolder | ICustomer | any): string {
        return this.travellerDataTranslationService.translateType(traveller.type || traveller.xType);
    }
}
